import React from 'react';
import ReactDOM from 'react-dom';
import FilterIcon from './images/filter-icon.svg';
import DropdownIcon from './images/dropdownIcon.svg';
import './css/CollectionFilters.css';

class Filters extends React.Component{
    constructor(){
        super();
        this.state = {
            showFilters: false
        }
    }
    showFilters = () => {
        // var filters = document.querySelector('#collection-filters');
        var filters = document.querySelectorAll('.collection-filters');
        if(!this.state.showFilters){
            
            ReactDOM.render(<ShowFilters {...this.props} closeFilter={this.showFilters}/>, document.getElementById('filters-list'));
            document.getElementById('filters-list').classList.add('active');
            filters[0].classList.add('active');
            filters[1].classList.add('active');
            if(window.outerWidth < 524){
                document.body.style.overflow = 'hidden';
            }
            filters[0].querySelector('.dropdown-icon').style.transform = 'rotate(180deg)';
            filters[1].querySelector('.dropdown-icon').style.transform = 'rotate(180deg)';
        }else{
            filters[0].classList.remove('active');
            filters[1].classList.remove('active');
            document.getElementById('filters-list').classList.remove('active');
            document.body.style.overflow = 'auto';
            filters[0].querySelector('.dropdown-icon').style.transform = 'rotate(0deg)';
            filters[1].querySelector('.dropdown-icon').style.transform = 'rotate(0deg)';
            ReactDOM.unmountComponentAtNode(document.getElementById('filters-list'));
            // document.getElementById('filters-list').style.display = 'none';
        }
        var currentState = this.state.showFilters;
        this.setState({
            showFilters: !currentState
        });
    }
     render(){
         return (
             <div className={`collection-filters ${(this.props.filterApplied)?'applied':''}`} style={{padding:'1rem',justifyContent:'space-between',cursor:'pointer'}} onClick={this.showFilters}>
                <div className="filter-icon" style={{height:'1.2rem',width:'1.2rem'}}>
                    <img src={FilterIcon} alt="" style={{display:'block',height:'100%'}}/>
                </div>
                <div className="filter-text">
                    <span>Filters</span>
                </div>
                <div className='dropdown-icon' style={{height:'0.5rem',width:'1rem'}}>
                    <img src={DropdownIcon}  style={{display:'block',height:'100%'}} alt=""/>
                </div>
             </div>
            );
     }
}
export class ShowFilters extends React.Component{
    render(){
        let location = [];
        this.props.destination.forEach( element => {
            location.push(
            <div key={element.id} className="col-xl-4 col-md-4 col-sm-6" style={{paddingLeft:0,marginBottom:'0.8rem'}}>
                <label>
                    <input type="checkbox" value={element.id} defaultChecked={(this.props.locationFilterApplied.includes(element.id))?true:false} onChange={this.props.locationFilter}/>
                    <span className="checkbox"></span>
                    <span>{element.name}</span>
                </label>
            </div>
            );
        });
    
        let categories = [];
        this.props.category.forEach( element => {
            categories.push(
                <div key={element.id} className="col-xl-6 col-md-6 col-sm-12" style={{paddingLeft:0,marginBottom:'0.8rem'}}>
                    <label>
                        <input type="checkbox" ref={(input) => { this.textInput = input; }} defaultChecked={(this.props.categoryFilterApplied.includes(element.id))?true:false} value={element.id}  onChange={this.props.categoryFilter}/>
                        <span className="checkbox"></span>
                        <span>{element.name}</span>
                    </label>
                </div>
                );
        });
        return (
            <div style={{position:'relative'}}>
            <div>
                <div className="container row" style={{height:'100%',width:'100%',padding:'0 0 1rem',alignItems:'flex-start'}}>
                    <div className="col-xl-6 col-sm-12 col-md-6 destination-filters">
                        <div style={{marginBottom:'0.5rem'}}>
                            <span style={{fontSize:'1.2rem',fontWeight:'500'}}>Destination</span>
                        </div>
                        <div className="row">
                            {location}
                        </div>
                    </div>
                    <div className="col-xl-6 col-sm-12 col-md-6 category-filters">
                        <div style={{marginBottom:'0.5rem'}}>
                            <span style={{fontSize:'1.2rem',fontWeight:'500'}}>Categories</span>
                        </div>
                        <div className="row">
                            {categories}
                        </div>
                    </div>
                </div>
            </div>
            <div className="closeFilter" onClick={this.props.closeFilter}>
                <span></span>
            </div>
            </div>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/Filters.jsx